document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: none)').matches) return;

  var chevronLeft = '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;display:block;"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var chevronRight = '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;display:block;"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function setupCard(media, secondImg) {
    var imgUrl = secondImg.currentSrc || secondImg.src;
    if (!imgUrl) return;

    // Wrap the ORIGINAL media element without changing its own styles
    var wrapper = document.createElement('div');
    wrapper.className = 'mockup-wrapper';
    media.parentNode.insertBefore(wrapper, media);
    wrapper.appendChild(media);

    var overlay = document.createElement('div');
    overlay.className = 'mockup-overlay';
    overlay.style.backgroundImage = 'url(' + imgUrl + ')';
    wrapper.appendChild(overlay);

    var showingMockup = false;
    function toggle() {
      showingMockup = !showingMockup;
      overlay.classList.toggle('is-visible', showingMockup);
    }

    function makeButton(html, label, extraClass) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mockup-nav-btn ' + extraClass;
      btn.innerHTML = html;
      btn.setAttribute('aria-label', label);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });
      return btn;
    }

    wrapper.appendChild(makeButton(chevronLeft, 'Previous image', 'mockup-nav-btn--prev'));
    wrapper.appendChild(makeButton(chevronRight, 'Next image', 'mockup-nav-btn--next'));
  }

  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var media = card.querySelector('.media--hover-effect');
    if (!media) return;

    var secondImg = media.querySelector('img.media--second');
    if (!secondImg) return;

    if (secondImg.complete && (secondImg.currentSrc || secondImg.src)) {
      setupCard(media, secondImg);
    } else {
      secondImg.addEventListener('load', function () {
        setupCard(media, secondImg);
      });
    }
  });
});